import { useJsApiLoader } from '@react-google-maps/api'
import { get } from 'lodash'
import { setStoredLatLng, getStoredLatLng, loggedInUser, getLoggedInUserDisplayName, getLoggedInUserId } from '../v2_actions/auth'

const libraries = ["places"]

export const MINIMUM_ZOOM_FOR_SELECTING_LOCATION = 16
export const DEFAULT_ZOOM = 8

export const MAP_CENTER = "MAP_CENTER"

export const DEFAULT_LOCATIONS_BY_COUNTRY = { za: {lat: -31.364637526600113, lng: 24.70517530697458, zoom: 10},
                                              au: {lat: -25.072625580422045, lng: 134.12686793815917, zoom: 10},
                                              us: {lat: -25.072625580422045, lng: 134.12686793815917, zoom: 3 } }

export const getDefaultLocationForCountry = (country_code) => {
    return DEFAULT_LOCATIONS_BY_COUNTRY[country_code || 'us']
}

export const setMapCenter = ({lat, lng}) => {
    setStoredLatLng({lat,lng})
    if ( parseFloat(lat) && parseFloat(lng) ) {
        return {
            type: MAP_CENTER,
            lat: lat,
            lng: lng
        }
    } else {
        return {
            type: "noop"
        }
    }
}

export const getMapCenter = (state) => {
    return get(state, ["mapinfo", "center"])
}

export const getDefaultLocationForUser = () => {
    const { lat, lng } = getStoredLatLng()
    if ( ! lat || ! lng ) {
        return null
    } else {
        return {lat, lng, zoom: MINIMUM_ZOOM_FOR_SELECTING_LOCATION}
    }
}

export const getGoogleInitArgs = () => {
    return {
        id: 'google-map-script',
        googleMapsApiKey: window.LOCAL_SETTINGS.GOOGLE_MAP_KEY,
        libraries: libraries
    }
}
